export function drawFabricSwatch(canvas: HTMLCanvasElement, colour: string): void {
  canvas.width = canvas.height = 64;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Fabric swatch needs a canvas context');
  context.fillStyle = colour;
  context.fillRect(0, 0, 64, 64);
  for (let y = 0; y < 64; y += 4)
    for (let x = 0; x < 64; x += 4) {
      const over = ((x + y) / 4) % 4 < 2;
      context.fillStyle = 'rgba(0,0,0,0.32)';
      context.fillRect(x, y, over ? 1 : 4, over ? 4 : 1);
      context.fillStyle = 'rgba(255,235,192,0.22)';
      context.fillRect(x + 1, y + 1, over ? 2 : 3, over ? 3 : 2);
    }
}
